import { FC } from 'react';
import {
    NonAuthorizedContentWithImageLayout,
    RightColumnImage,
} from '../NonAuthorizedContentWithImageLayout';
import messageKeyboard from '../../images/messageKeyboard.svg';
import { VerifyCodeForm } from './components/VerifyAccountForm';
import { useVerifyCodeState } from '@/bo-kit/components/VerifyAccountPage/hooks/useVerifyCodeState';
import { Navigate } from 'react-router-dom';
import { useTranslation } from '@/ui-kit/hooks/useTranslation';

const VerifyAccountPageResponsive: FC<{ implementation?: 'js' | 'css' }> = ({ implementation }) => {
    const { t } = useTranslation('bo-kit__common');
    const state = useVerifyCodeState();
    if (!state) {
        return <Navigate to='/' />;
    }
    return (
        <NonAuthorizedContentWithImageLayout
            title={t('Sign Up')}
            implementation={implementation}
            content={<VerifyCodeForm {...state} />}
            image={<RightColumnImage src={messageKeyboard} />}
        />
    );
};

export default VerifyAccountPageResponsive;
